export enum Shortcuts {
	Today = 'today',
	Yesterday = 'yesterday',
	Last7 = 'last7',
	Last30 = 'last30',
	ThisMonth = 'thisMonth',
	LastMonth = 'lastMonth',
	AllTime = 'allTime',
}
